import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import BootstrapVue from "bootstrap-vue/dist/bootstrap-vue.esm";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import { BootstrapVueIcons } from "bootstrap-vue";
import VueQriously from "vue-qriously";
import store from "./store";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import VueMask from "v-mask";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import VueKonva from 'vue-konva';
import './registerServiceWorker';
import * as Sentry from "@sentry/vue";

const globalOptions = {
  mode: "auto",
};

Vue.use(VueTelInput, globalOptions);
Vue.use(BootstrapVueIcons);
Vue.use(BootstrapVue);
Vue.use(VueQriously);
Vue.use(VueMask);
Vue.use(VueKonva);
Vue.config.productionTip = false;

Vue.component("vue-typeahead-bootstrap", VueTypeaheadBootstrap);

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  sendDefaultPii: true
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
